import { createTheme } from '@mui/material/styles'
import { SHELL_BREAKPOINTS, CONTENT_BREAKPOINTS } from './breakpoints'
import { responsiveComponents } from './responsiveComponents'

/**
 * Theme for the application shell - the Toolpad `AppProvider` and
 * `DashboardLayout`. Its `md` breakpoint is what decides between the permanent
 * sidebar and the mobile drawer.
 */
export const shellTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-toolpad-color-scheme'
  },
  colorSchemes: { light: true },
  breakpoints: { values: SHELL_BREAKPOINTS },
  palette: {
    background: {
      default: '#f5f5f5'
    }
  },
  components: responsiveComponents
})

/**
 * Theme for page content, nested inside the shell. Pages were written against
 * its wider `md`/`lg` (1400), so those values are unchanged.
 */
export const contentTheme = createTheme({
  breakpoints: { values: CONTENT_BREAKPOINTS },
  palette: {
    background: {
      default: '#FFFFFF'
    }
  },
  components: responsiveComponents
})

/** Theme for the signed-out pages, which have no dashboard shell around them. */
export const unauthenticatedTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-toolpad-color-scheme'
  },
  colorSchemes: { light: true },
  breakpoints: { values: SHELL_BREAKPOINTS },
  palette: {
    background: {
      default: '#f5f5f5'
    }
  },
  components: responsiveComponents
})
